import {getAxiosInstance} from '../helpers/axios-helper'

const baseUrl = process.env.BACKEND_URL

function changeLeaderBoard(gameId, isLeaderDisabled) {
  return getAxiosInstance().patch(`${baseUrl}/games/${gameId}/teamleaderboard`, {
    isLeaderDisabled: isLeaderDisabled,
  })
    .then(game => {
      return game.data
    })
    .catch(err => {
      throw err
    })
}

export default {
  changeLeaderBoard,
}
